import {
  StatisticsDescription as StatisticsDescriptionStyled,
  DescriptionLink,
  ReadMoreButton,
  DescriptionWrapper,
} from '../styles';

const StatisticsDescription = ({ description, truncateAt, isExpanded, onToggle }) => {
  if (Array.isArray(description)) {
    const fullText = description
      .map((part) => (part.type === 'link' ? part.text : part.content || ''))
      .join('');

    const shouldTruncate = truncateAt && fullText.length > truncateAt;

    return (
      <DescriptionWrapper>
        <StatisticsDescriptionStyled>
          {isExpanded || !shouldTruncate
            ? description.map((part, index) =>
                part.type === 'link' ? (
                  <DescriptionLink
                    key={index}
                    href={part.href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {part.text}
                  </DescriptionLink>
                ) : (
                  part.content
                )
              )
            : fullText.substring(0, truncateAt) + '...'}
        </StatisticsDescriptionStyled>

        {shouldTruncate && (
          <ReadMoreButton onClick={onToggle}>
            {isExpanded ? 'read less' : 'read more'}
          </ReadMoreButton>
        )}
      </DescriptionWrapper>
    );
  }

  const shouldTruncate = truncateAt && description?.length > truncateAt;

  return (
    <DescriptionWrapper>
      <StatisticsDescriptionStyled>
        {isExpanded || !shouldTruncate
          ? description
          : description?.substring(0, truncateAt) + '...'}
      </StatisticsDescriptionStyled>

      {shouldTruncate && (
        <ReadMoreButton onClick={onToggle}>{isExpanded ? 'read less' : 'read more'}</ReadMoreButton>
      )}
    </DescriptionWrapper>
  );
};

export default StatisticsDescription;
